/**
 * Takes in a function that has its last 2 parameters as success and failure callbacks,
 * and returns a function with the same other parameters that returns a promise.
 * @param fn
 * @return {function(...[*]): Promise<unknown>}
 */
export function promisify(fn) {
    return (...params) => new Promise((resolve, reject) => fn(...params, resolve, reject));
}
